import React from 'react';
import { StyleSheet, Text, View, Dimensions } from 'react-native';
import { createStackNavigator, HeaderTitle , CardStyleInterpolators, TransitionPresets} from 'react-navigation-stack';
import { createAppContainer, createSwitchNavigator } from 'react-navigation';
import SelectionScreen from './screens/SelectionScreen';
import LoginScreen from './screens/LoginScreen';
import AdminsScreen from './screens/AdminsScreen';
import UserScreen from './screens/UserScreen';
import UserLoginScreen from './screens/UserLoginScreen';
import EdeklaracjaScreen from './screens/EdeklaracjaScreen'


const MainNavigator = createSwitchNavigator({
selection: SelectionScreen,
login: LoginScreen,
userLogin: UserLoginScreen,
admin: AdminsScreen,
user: UserScreen,
edeklaracja: EdeklaracjaScreen,
},{
    mode: 'card',
    animationEnabled: true, 
    initialRouteName: 'selection' ,
    defaultNavigationOptions: {
        header: null, 
                 
}})

export default createAppContainer(MainNavigator)